var Kowloon = "Cửu Long";
var HKStates = {
	"Hong Kong Island": "Đảo Hồng Kông",
	Kowloon: Kowloon,
	"Lantau Island": "Đảo Lạn Đầu",
	"New Territories": "Tân Giới"
};

export { Kowloon, HKStates as default };
